import { render, staticRenderFns } from "./Lux-Voyages-Impressum.vue?vue&type=template&id=b363a46c&"
import script from "./Lux-Voyages-Impressum.vue?vue&type=script&lang=js&"
export * from "./Lux-Voyages-Impressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports